import { render } from "./THissue.vue?vue&type=template&id=29152eac&scoped=true"
import script from "./THissue.vue?vue&type=script&lang=js"
export * from "./THissue.vue?vue&type=script&lang=js"

import "./THissue.vue?vue&type=style&index=0&id=29152eac&lang=scss&scoped=true"
import "./THissue.vue?vue&type=style&index=1&id=29152eac&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29152eac"]])

export default __exports__